<template>
  <van-nav-bar title="订餐" left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar>

  <div class="publishDes" style="margin: 10px 28px 20px">
    <span>{{ companyName }}</span>
    <span>缴费名称：{{ detail.cost_name }}</span>
    <span>缴费金额：{{ detail.cost }}元</span>
    <span>就餐天数：{{ detail.days }}</span>
    <span>发布时间：{{ detail.publish_date }}</span>
    <span>订餐截止：{{ detail.end_date }}</span>
    <span 
      >订餐状态：
      <strong :style="[{ color: detail.status === 0 ? 'blue' : 'red'}]">
        {{ detail.status == 0 ? "未订餐" : "已订餐" }}</strong
      >
    </span>
    <span>订餐描述: {{ detail.describe }}</span>
    <van-grid :column-num="3">
      <van-grid-item v-for="item in detail.menu_img" :key="item">
        <van-image :src="item" />
      </van-grid-item>
    </van-grid>
  </div>

  <div v-if="detail.status == 0" style="margin: 60px 16px">
    <van-button round block type="primary" @click="showPopup"> 确认订餐 </van-button>
  </div>

  <van-popup v-model:show="show" closeable position="bottom" :style="{ height: '50%' }">
    <div style="margin-top: 20px">
      <van-cell :value="companyName" />
      <van-cell title="订单名称" :value="detail.cost_name" />
      <van-cell title="订单金额" :value="'¥' + detail.cost" />
      <van-config-provider :theme-vars="themeVars">
      <van-cell
        title="*此订单为先用餐后付费模式,缴费金额将根据实际用餐天数计算.确认后线上无法修改订单."
      />
      </van-config-provider>
    </div>

    <div style="margin: 30px 16px">
      <van-button round block type="primary" @click="toOrderPopup"> 确认订餐 </van-button>
    </div>
  </van-popup>
</template>

<script>
import { onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRoute, useRouter } from "vue-router";
import api from "../service/api";

export default {
  setup() {
    const show = ref(false);
    const Route = useRoute(); //获取值时使用
    const router = useRouter(); //跳转使用
    const companyName = ref("");
    const charge_restaurant_id = ref("");

    const detail = ref({});
    const themeVars = {
     cellTextColor	: '#F01526',
    };
    const onClickLeft = () => {
      router.go(-1);
    };
    const showPopup = () => {
      //下单
      show.value = true;
    };
    const toOrderPopup = () => {
      show.value = false;
      toOrder();
    };

    onMounted(() => {
      companyName.value = Route.query.companyName;
      charge_restaurant_id.value = Route.query.charge_restaurant_id;
      onLoad();
    });

    const toOrder = () => {
      api
        .createRestaurantOrder({
          child_id: localStorage.getItem("childId"),
          charge_restaurant_id: charge_restaurant_id.value,
          school_id: localStorage.getItem("schoolId"),
          class_id: localStorage.getItem("classId"),
          payment: detail.value.cost,
        })
        .then((res) => {
          if (res.data.code == 1001) {
            Toast(res.data.message);
            detail.value.status = 1;
            // let result = res.data.result;
          } else {
            Toast(res.data.message);
          }
        })
        .catch((err) => {
          Toast(err.message);
        });
    };
    const onLoad = () => {
      api
        .getOrderDetail({
          charge_restaurant_id: Route.query.charge_restaurant_id,
          child_id: localStorage.getItem("childId"),
          class_id: localStorage.getItem("classId"),
        })
        .then((res) => {
          if (res.data.code == 1001) {
            detail.value = res.data.result;
          } else {
            Toast(res.data.message);
          }
        })
        .catch((err) => {
          Toast(err.message);
        });
    };

    return {
      show,
      detail,
      showPopup,
      toOrderPopup,
      toOrder,
      onClickLeft,
      companyName,
      charge_restaurant_id,
      themeVars,
    };
  },
};
</script>

<style lang="less">
.publishDes {
  display: block;
  margin-left: 10px;
  line-height: 20px;
  font-size: 14px;
  span {
    display: block;
    font-size: 14px;
    padding: 2px 0;
    text-align: left;
  }
}
</style>
